import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const PriorityContainerCommon = styled.div`
  display: flex;
  flex-direction: column;
  width: 93px;
  align-items: center;
  height: 100%;
  margin-top: 25px;
`;

export const PriorityNumberCommon = styled.div`
  width: 93px;
  padding: 4px 12px;
  border-radius: 100%;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) =>
    props.theme.atlas.semantic.color.action.primary.onPrimary};
  background: ${(props) =>
    props.theme.atlas.semantic.color.action.primary.default};
  border: solid 1px
    ${(props) => props.theme.atlas.semantic.color.action.primary.default};
  width: fit-content;
  z-index: 1;
`;
